<div class="search-page">
  <app-content-tabs [hidden]="entityId" [territoryUid]="territoryUid"/>
  <app-content [territoryUid]="territoryUid" />
</div>
